import { useShallow } from "zustand/shallow";
import { IUserProfile } from "@miplatform/types";
import { useUserStore } from "../../stores";

export const useProfile = (): {
  getProfile: (userId: string) => Promise<void>;
  profile: IUserProfile | null;
} => {
  return useUserStore(
    useShallow((state) => ({
      profile: state.profile,
      getProfile: state.getProfile,
    }))
  );
};
